import { Injectable } from '@angular/core';
import { DeviceInfo, OperatingSystem } from '@capacitor/device';

@Injectable()
export class DeviceService {
    private _device: Readonly<DeviceInfo>;

    initialize(deviceInfo: DeviceInfo): void {
        this._device = { ...deviceInfo };
    }

    systemIs(operatingSystem: OperatingSystem): boolean {
        return this._device.operatingSystem === operatingSystem;
    }
}

